/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DeploymentMode {
    Mandatory = 'MANDATORY',
    Recommended = 'RECOMMENDED',
    User = 'USER'
}

export function DeploymentModeFromJSON(json: any): DeploymentMode {
    return DeploymentModeFromJSONTyped(json, false);
}

export function DeploymentModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentMode {
    return json as DeploymentMode;
}

export function DeploymentModeToJSON(value?: DeploymentMode | null): any {
    return value as any;
}

